export default {
  header: {
    title: 'Código promocional o tarjeta regalo',
  },
  available_codes: {
    title_one: 'Código disponible ({{count}})',
    title_other: 'Códigos disponibles ({{count}})',
    min_threshold: 'Mín. {{value}}',
    percentage_off: '{{discount}}% dto. en este pedido',
    amount_off: '{{amount}} dto. en este pedido',
  },
  content: {
    input: {
      placeholder: 'Introduce un código',
    },
    buttons: {
      done: 'Listo',
      apply: 'Aplicar',
      applied: 'Aplicado ✓',
    },
  },
};
